
export enum ThemeProperty {
	Primary = 'primary',
	Secondary = 'secondary',
	Accent = 'accent',
	TopBar = 'topBar',
	SideNav = 'sideNav',
	SideNavScroll = 'sideNavScroll',
	Loaders = 'loaders',
	Base = 'base',
	ModuleTopBar = 'moduleTopBar',
	CardHeader = 'cardHeader',
	CardFooter = 'cardFooter'
}
